module.exports = __webpack_public_path__ + "static/icon__design--multicolor-2d0101093583e8829ab38a90a208ac98.png";